import React, { Suspense, useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { useTranslation } from 'react-i18next';
import { Box, Grid, InputAdornment, Link, TextField } from '@mui/material';
import CurrencyFormatField from 'components/common/CurrencyFormatField';
import { TransportationModel, TransportationStatus } from 'models/TransportationModel';
import auth from 'recoil/atoms/auth';
import Api from 'utils/api';
import { replaceItemAtIndex } from 'utils/common';


const CanceledInner = () => {
    const my = useRecoilValue(auth);
    const {t} = useTranslation();
    const [transportations, setTransportations] = useState<TransportationModel[]>([]);

    useEffect(() => {
        Api.transportation
            .all(TransportationStatus.Canceled)
            .then(res => setTransportations(res.data));
    }, []);

    return (
        <>
            {transportations.map(order => (
                <Grid container>
                    <Grid item xs={4}>
                        {order.car.make} {order.car.model}<br/>
                        <Link href={`/car/${order.car.id}`}>{order.car.chassisNumber}</Link>
                    </Grid>
                    <Grid item xs={8}>
                        {order.note}
                    </Grid>
                </Grid>
            ))}
        </>
    )
};


const Canceled = () => {
    return (
        <Suspense fallback={null}>
            <CanceledInner/>
        </Suspense>
    )
};

export default Canceled;
